import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="loading-screen">
                <div className="flex items-center gap-3">
                    <div className="h-3 w-3 rounded-full bg-[#6C63FF] animate-pulse" />
                    Loading…
                </div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/auth" state={{ from: location }} replace />;
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/" replace />;
    }
    return children;
}
